import { updateSearchString } from '../../../../utils/shared/urlUtils';
import { VOCABO_MEASURE } from '../../../../constants/shared/MeasuresConstants';

const { TQVM, FITB, BD } = VOCABO_MEASURE;

const VOCABO_TABS = [
    {
        id: TQVM,
        title: TQVM,
    },
    {
        id: FITB,
        title: FITB,
    },
    {
        id: BD,
        title: BD,
    },
];

const getVocaboTabs = (vocaboMeasures, location) =>
    VOCABO_TABS.filter(({ id }) => vocaboMeasures.includes(id)).map(tab => ({
        ...tab,
        path: {
            search: updateSearchString(location, [], { tab: tab.id }),
        },
    }));

export default getVocaboTabs;
